import { Icon, toIconsEnum } from 'components/Icons';

import { AnchorLink } from 'components/anchorLink';
import styles from './SportNavHighlightItem.module.scss';

export type SportNavHighlightItemProps = {
  gruppoId: string;
  descrizione: string;
  href: string;
};

export const SportNavHighlightItem = ({ gruppoId, descrizione, href }: SportNavHighlightItemProps) => {
  return (
    <div className={styles.container} suppressHydrationWarning>
      <Icon iconId={toIconsEnum(`GRUPPO_${gruppoId}`)} className={styles.icon} color="var(--color-neutral-01)" />
      <AnchorLink href={`${href}`} className={styles.text}>
        {descrizione}
      </AnchorLink>
    </div>
  );
};
